
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription, SheetTrigger } from "@/components/ui/sheet";
import { PrayerComments } from "./PrayerComments";
import { PrayerRequestCard } from "./PrayerRequestCard";
import { useState } from "react";

interface PrayerRequest {
  id: number;
  title: string;
  content: string;
  created_at: string;
  user_id: string;
  is_anonymous?: boolean;
}

interface Props {
  request: PrayerRequest;
  likes: number;
  comments: any[];
  isAdmin: boolean;
  userHasLiked: boolean;
  onLike: (id: number, e: React.MouseEvent) => void;
  onDelete: (id: number) => void;
  onReport: (type: 'prayer' | 'comment', id: number) => void;
  onCommentAdded: () => void;
  onAmen?: (id: number, e: React.MouseEvent) => void;
}

export function PrayerRequestListItem({
  request,
  likes,
  comments,
  isAdmin,
  userHasLiked,
  onLike,
  onDelete,
  onReport,
  onCommentAdded,
  onAmen
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  // Handle reporting without opening the sheet
  const handleReport = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    onReport('prayer', id);
  };

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <div className="cursor-pointer">
          <PrayerRequestCard
            request={request}
            likes={likes}
            comments={comments?.length || 0}
            isAdmin={isAdmin}
            userHasLiked={userHasLiked}
            onLike={onLike}
            onDelete={onDelete}
            onReport={handleReport}
            onAmen={onAmen}
          />
        </div>
      </SheetTrigger>
      <SheetContent className="w-full sm:max-w-lg bg-gradient-to-br from-white to-grace-light/10 border-grace/20">
        <SheetHeader className="space-y-4 pb-6">
          <SheetTitle className="text-2xl font-semibold text-grace-dark">
            {request.title}
          </SheetTitle>
          <SheetDescription className="text-gray-700 leading-relaxed">
            {request.content}
          </SheetDescription>
        </SheetHeader>
        <PrayerComments 
          requestId={request.id}
          comments={comments || []}
          isAdmin={isAdmin}
          onCommentAdded={onCommentAdded}
        />
      </SheetContent>
    </Sheet>
  );
}
